import React from 'react';
import { HazardStripe } from './HazardStripe';
export function Footer() {
  return <footer className="bg-ink text-center" data-id="element-83" data-mp="3geze367ujv27">
      <HazardStripe className="h-1.5" data-id="element-84" data-mp="3ggty8ibanj58" />
      <div className="px-3 py-3 sm:px-6" data-id="element-85" data-mp="32nul2myzi10u">
        <p className="text-[0.66rem] font-semibold text-white/85 sm:text-[0.76rem]" data-id="element-86" data-mp="32ovvcp86ejhi">
          © 2026 CONSTRUCTION SITE PRO™ — All Rights Reserved.
        </p>
        <p className="mx-auto mt-1 max-w-2xl text-[0.62rem] leading-[1.45] text-steel sm:text-[0.72rem]" data-id="element-87" data-mp="3uf0n58y9m8sr">
          CONSTRUCTION SITE PRO™ is an educational and professional management resource. It does not
          guarantee project completion dates, cost savings, regulatory compliance, construction
          quality, or specific project outcomes. It does not replace applicable construction
          regulations, workplace safety requirements, approved plans, contractual procedures,
          specialized technical assessments, engineering evaluations, or qualified professional
          judgment.
        </p>
        <p className="mt-1 text-[0.62rem] text-steel sm:text-[0.72rem]" data-id="element-88" data-mp="3l90n1twdyuy7">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-hazard" data-id="element-89" data-mp="3gagz5ny8f937">
            Terms &amp; Conditions
          </a>{' '}
          •{' '}
          <a href="#" className="transition-colors duration-150 ease-out hover:text-hazard" data-id="element-90" data-mp="3v9b09eif82dd">
            Privacy Policy
          </a>{' '}
          •{' '}
          <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-hazard" data-id="element-91" data-mp="82idhvaq8efw">
            Contact
          </a>
        </p>
        <p className="mt-0.5 text-[0.62rem] text-steel sm:text-[0.72rem]" data-id="element-92" data-mp="31umvaqetzm7">
          Support:{' '}
          <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-hazard" data-id="element-93" data-mp="huo533x2gtuk">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}